var GlossaryManager = function () {
    var root = this;

    var cachedIngredients = null,
        cachedProducts = null,
        tile = '',
        desktopWidth = 3,
        tabletWidth = 4,
        mobileWidth = 6,
        enableSearch = true,
        enableBenefit = true,
        enableEwgRating = true,
        enableAllergens = true,
        enableSortBy = true,
        activeSortBy = 'Title ASC',
        activeSearch = '',
        activeFilters = {},
        $activePopup = null;

    var loadPagedIngredients = function (page) {
        $.ajax({
            url : '/pages/ingredients-api?p=' + page,
            type : "get",
            async: false,
            success : function(data) {
                var response = JSON.parse(data);

                if(response.hasOwnProperty('ingredients')) {
                    for(var i = 0; i < response['ingredients'].length; i++) {
                        cachedIngredients.push(response['ingredients'][i]);
                    }
                }

                if(response.hasOwnProperty('next_page') && response['next_page'] !== null) {
                    loadPagedIngredients(page + 1);
                }
            }
        });
    }

    var getIngredients = function () {
        if(cachedIngredients === null) {
            cachedIngredients = [];
            loadPagedIngredients(0);
        }

        return cachedIngredients;
    }

    var loadPagedProducts = function (page) {
        $.ajax({
            url : '/pages/products-api?p=' + page,
            type : "get",
            async: false,
            success : function(data) {
                var response = JSON.parse(data);

                if(response.hasOwnProperty('products')) {
                    for(var i = 0; i < response['products'].length; i++) {
                        cachedProducts.push(response['products'][i]);
                    }
                }

                if(response.hasOwnProperty('next_page') && response['next_page'] !== null) {
                    loadPagedProducts(page + 1);
                }
            }
        });
    }

    var getProducts = function () {
        if(cachedProducts === null) {
            cachedProducts = [];
            loadPagedProducts(0);
        }

        return cachedProducts;
    }

    var getProductsWithIngredient = function (ingredientHandle, limit) {
        var allProducts = getProducts(),
            matchedProducts = [];

        for(var i = 0; i < allProducts.length; i++) {
            var allIngredients = allProducts[i]['metafields']['all_ingredients'];

            if(!allIngredients) {
                continue;
            }

            var ingredients = allIngredients.split('|');

            for(var j = 0; j < ingredients.length; j++) {
                if(ingredients[j] === ingredientHandle) {
                    matchedProducts.push(allProducts[i]);
                    break;
                }
            }

            if(matchedProducts.length === limit) {
                break;
            }
        }

        return matchedProducts;
    }

    var isIngredientEWGRating = function (ingredient, filterValue) {
        var ewgRating = ingredient['metafields']['ewg_ranking'];

        filterValue = parseInt(filterValue);

        if(ewgRating === 'not on the database') {
            return false;
        }

        var split = ewgRating.split(','),
            oneMatched = false;

        for(var j = 0; j < split.length; j++) {
            var part = split[j].replace(/\s/g, '');

            if(part.indexOf('-') !== -1) {
                var rangePart = part.split('-');

                if(filterValue >= parseInt(rangePart[0]) && filterValue <= parseInt(rangePart[1])) {
                    oneMatched = true;
                }
            } else {
                if(filterValue === parseInt(part)) {
                    oneMatched = true;
                }
            }
        }

        return oneMatched;
    }

    var getFilteredIngredients = function () {
        var ingredients = getIngredients(),
            isFiltered = false;

        for(var key in activeFilters) {
            if(activeFilters.hasOwnProperty(key)) {
                if(activeFilters[key] !== '') {
                    isFiltered = true;
                }
            }
        }

        if(!isFiltered) {
            return ingredients;
        }

        var filteredIngredients = [];

        for(var i = 0; i < ingredients.length; i++) {
            var ingredient = ingredients[i],
                matched = true;

            for (var key in activeFilters) {
                if (activeFilters.hasOwnProperty(key)) {
                    var filterValue = activeFilters[key];

                    if(filterValue === '') {
                        continue;
                    }

                    if (key === 'EWG Rating') {
                        matched = isIngredientEWGRating(ingredient, filterValue);

                        if(matched === false) {
                            break;
                        }
                    }

                    if (key === 'Allergens') {
                        if(ingredient['metafields']['allergens'] !== null && ingredient['metafields']['allergens'] !== '' && ingredient['metafields']['allergens'].includes(filterValue)) {
                            matched = false;
                            break;
                        }
                    }
                }
            }

            if(matched) {
                filteredIngredients.push(ingredient);
            }
        }

        return filteredIngredients;
    };

    var getBenefitOptions = function() {
        var ingredients = getFilteredIngredients(),
            benefitOptions = [];

        for(var i = 0; i < ingredients.length; i++) {
            var benefit = ingredients[i]['metafields']['benefit'];

            if(benefitOptions.indexOf(benefit) === -1 && benefit !== '' && benefit !== null) {
                benefitOptions.push(benefit);
            }
        }

        return benefitOptions;
    };

    var getEwgRatingOptions = function () {
        var validOptions = [];

        for(var i = 1; i <= 10; i++) {
            var ingredients = getIngredients();

            for(var j = 0; j < ingredients.length; j++) {
                if(isIngredientEWGRating(ingredients[j], i)) {
                    validOptions.push(i);
                    break;
                }
            }
        }

        return validOptions;
    }

    var getAllergensOptions = function () {
        var ingredients = getIngredients(),
            options = [];

        for(var i = 0; i < ingredients.length; i++) {
            var ingredient = ingredients[i];

            if(ingredient['metafields']['allergens'] !== null && ingredient['metafields']['allergens'] !== '') {
                var allergens = ingredient['metafields']['allergens'].split('|');
                for(var j = 0; j < allergens.length; j++) {
                    if(options.indexOf(allergens[j]) === -1) {
                        options.push(allergens[j]);
                    }
                }
            }
        }

        return options;
    }

    var getSortByIngredients = function () {
        var ingredients = getSearchedIngredients();

        if(activeSortBy === 'Title ASC') {
            ingredients.sort((a, b) => (a.title > b.title) ? 1 : -1);
        } else if(activeSortBy === 'Title DESC') {
            ingredients.sort((a, b) => (b.title > a.title) ? 1 : -1);
        }

        return ingredients;
    };

    var getSearchedIngredients = function () {
        var ingredients = getFilteredIngredients();

        if(activeSearch === '') {
            return ingredients;
        }

        var matchedIngredients = [];

        for(var i = 0; i < ingredients.length; i++) {
            var ingredient = ingredients[i];

            if(ingredient['title'].toLowerCase().includes(activeSearch.toLowerCase())) {
                matchedIngredients.push(ingredient);
            }
        }

        return matchedIngredients;
    };

    var onSortByChange = function (value) {
        activeSortBy = value;
        doRenderGrid();
    };

    var onSearchSubmit = function (value) {
        activeSearch = value;
        doRenderGrid();
    }

    var onFilterChange = function (name, value) {
        activeFilters[name] = value;
        doRenderGrid();
    };

    var doRenderGrid = function () {
        var ingredients = getSortByIngredients(),
            $gridItems = $('#glossary-grid-items').html('');

        $gridItems.append($('<div class="tile col-xl-' + desktopWidth + ' col-md-' + tabletWidth + '"><div class="wrapped">' + tile + '</div></div>'));

        for(var i = 0; i < ingredients.length; i++) {
            var ingredient = ingredients[i],
                $ingredient = $('<div class="col-xl-' + desktopWidth + ' col-md-' + tabletWidth + ' col-' + mobileWidth + '"></div>').data('ingredient', ingredient),
                $wrapped = $('<div class="wrapped"></div>'),
                $title = $('<h3 class="title">' + ingredient['title'] + '</h3>'),
                $excerpt = $('<p class="excerpt">' + ingredient['excerpt'] + '</p>'),
                $imagePlaceholder = $('<div class="image-placeholder"></div>'),
                $image = $('<img class="image" src="' + ingredient['image']['src'] + '" alt="' + ingredient['image']['alt'] + '" />');

            $wrapped.append($title);
            $wrapped.append($excerpt);
            $wrapped.append($imagePlaceholder);
            $wrapped.append($image);
            $ingredient.append($wrapped)

            $gridItems.append($ingredient);

            $ingredient.click(function () {
                showIngredientGridPopup($(this).data('ingredient'));
            });
        }
    };

    this.setTileHTML = function(t) {
        tile = t;
    };

    this.setGridWidths = function(dW, tW, mW) {
        desktopWidth = dW;
        tabletWidth = tW;
        mobileWidth = mW;
    };

    this.setFilteringSettings = function(eS, eB, eSB) {
        enableSearch = eS;
        enableBenefit = eB;
        enableSortBy = eSB;
    };

    this.renderFiltering = function (domId) {
        var $filtering = $('#' + domId),
            $form = $('<form></form>');

        if(enableSearch) {
            var $searchContainer = $('<div class="search-container"></div>'),
                $search = $('<input type="text" name="search" placeholder="SEARCH INGREDIENTS">'),
                $button = $('<button type="submit"></button>');

            $searchContainer.append($search);
            $searchContainer.append($button);

            $form.append($searchContainer);
        }

        if(enableSortBy) {
            var $sortByContainer = $('<div class="sort-by-container"></div>'),
                $sortBy = $('<select name="sort-by"><option value="Title ASC">Title ASC</option><option value="Title DESC">Title DESC</option></select>');

            $sortByContainer.append($sortBy);
            $form.append($sortByContainer);

            $sortBy.change(function() {
                onSortByChange($(this).val());
            });
        }

        if(enableBenefit || enableEwgRating || enableAllergens) {
            var $filterContainer = $('<div class="filter-container"></div>'),
                $label = $('<label>Filter by</label>');

            $filterContainer.append($label);

            if(enableBenefit) {
                var $benefit = $('<select name="benefit"></select>'),
                    $benefitPlaceholder = $('<option value="">Benefit</option>'),
                    benefitOptions = getBenefitOptions();

                $benefit.append($benefitPlaceholder);

                for (var i = 0; i < benefitOptions.length; i++) {
                    $benefit.append($('<option value="' + benefitOptions[i] + '">' + benefitOptions[i] + '</option>'));
                }

                $filterContainer.append($benefit);
            }

            if(enableEwgRating) {
                var $ewgRating = $('<select name="EWG Rating"></select>'),
                    $ewgPlaceholder = $('<option value="">EWG Rating</option>'),
                    ewgRatingOptions = getEwgRatingOptions();

                $ewgRating.append($ewgPlaceholder);

                for (var i = 0; i < ewgRatingOptions.length; i++) {
                    $ewgRating.append($('<option value="' + ewgRatingOptions[i] + '">' + ewgRatingOptions[i] + '</option>'));
                }

                $ewgRating.change(function () {
                    onFilterChange($(this).attr('name'), $(this).val());
                })

                $filterContainer.append($ewgRating);
            }

            if(enableAllergens) {
                var $allergens = $('<select name="Allergens"></select>'),
                    $allergensPlaceholder = $('<option value="">Exclude Allergens</option>'),
                    allergensOptions = getAllergensOptions();

                $allergens.append($allergensPlaceholder);

                for (var i = 0; i < allergensOptions.length; i++) {
                    $allergens.append($('<option value="' + allergensOptions[i] + '">' + allergensOptions[i] + '</option>'));
                }

                $allergens.change(function () {
                    onFilterChange($(this).attr('name'), $(this).val());
                })

                $filterContainer.append($allergens);
            }

            $form.append($filterContainer);
        }

        $form.submit(function (e) {
            e.preventDefault();

            if(enableSearch) {
                onSearchSubmit($(this).find('.search-container > input').val());
            }
        });

        $filtering.append($form);
    };

    this.renderIngredientsGrid = function (domId) {
        var $grid = $('#' + domId),
            $html = $('<div id="glossary-grid-items" class="row"></div>');

        $grid.append($html);

        doRenderGrid();
    };

    var showIngredientGridPopup = function (ingredient) {
        if($activePopup !== null) {
            $activePopup.remove();
        }

        $activePopup = $('<div id="glossary-ingredient-popup"></div>');

        var $close = $('<div class="exit"><img src="//cdn.shopify.com/s/files/1/0279/5857/5181/t/7/assets/icon-close.svg?v=7978040728439276017" alt="Close"></div>'),
            $ingredientInfo = $('<div class="ingredient-info"></div>'),
            $image = $('<img class="image" src="' + ingredient['image']['src'] + '" alt="' + ingredient['image']['alt'] + '" />'),
            $infoWrapped = $('<div class="info-wrapped"></div>'),
            $title = $('<h3 class="title">' + ingredient['title'] + '</h3>'),
            $excerpt = $('<p class="excerpt">' + ingredient['excerpt'] + '</p>');

        $infoWrapped.append($title);
        $infoWrapped.append($excerpt);

        if(ingredient['metafields']['function'] !== null && ingredient['metafields']['function'] !== '') {
            $infoWrapped.append($('<div class="metafield"><div class="label">FUNCTION</div><div class="value">' + ingredient['metafields']['function'] + '</div></div>'));
        }

        if(ingredient['metafields']['benefit'] !== null && ingredient['metafields']['benefit'] !== '') {
            $infoWrapped.append($('<div class="metafield"><div class="label">BENEFIT</div><div class="value">' + ingredient['metafields']['benefit'] + '</div></div>'));
        }

        if(ingredient['metafields']['ewg_ranking'] !== null && ingredient['metafields']['ewg_ranking'] !== '' && ingredient['metafields']['ewg_ranking'] !== 'not on the database') {
            $infoWrapped.append($('<div class="metafield inline"><div class="label">EWG RATING</div><div class="value">' + ingredient['metafields']['ewg_ranking'] + '</div></div>'));
        }

        if(ingredient['metafields']['allergens'] !== null && ingredient['metafields']['allergens'] !== '') {
            $infoWrapped.append($('<div class="metafield inline"><div class="label">ALLERGENS</div><div class="value">' + ingredient['metafields']['allergens'].replaceAll('|', ', ') + '</div></div>'));
        }


        $ingredientInfo.append($image);
        $ingredientInfo.append($infoWrapped);

        $activePopup.append($close);
        $activePopup.append($ingredientInfo);

        var products = getProductsWithIngredient(ingredient['handle'], 3);

        if(products.length > 0) {
            var $products = $('<div class="products-info row"></div>');

            for(var i = 0; i < products.length; i++) {
                var product = products[i],
                    $product = $('<div class="product-item col-md-4 col-12"></div>'),
                    $productImage = $('<div class="image-wrapper"><a href="/products/' + product['handle'] + '"><img alt="' + product['title'] + '" src="' + product['images'][0]  + '"</a></div>'),
                    $productName = $('<a class="product-name" href="/products/' + product['handle'] + '">' + product['title'] + '</a>'),
                    $productPrice = $('<div class="product-price">' + Shopify.formatMoney(product['variants'][0]['price'], Shopify.money_with_currency_format) + '</div>');

                $product.append($productImage);
                $product.append($productName);
                $product.append($productPrice);

                $products.append($product);
            }

            $activePopup.append($products);
        }

        $close.click(function () {
            $activePopup.fadeOut(function () {
                $activePopup.remove();
            });
        });

        $activePopup.hide();

        $('body').append($activePopup.fadeIn());
    }
}
